import { ActionAccessControll } from "@/types/public";
import { LocalParticipant, RemoteParticipant, Room } from "livekit-client";

export function useChangeActionAccess({
  user,
  room,
}: {
  room?: Room | undefined;
  user: LocalParticipant | RemoteParticipant;
}) {
  const changeActionAccess = (
    type: "lock" | "unlock",
    target: "mic" | "cam" | "screen"
  ) => {
    if (!room || !user || !room.localParticipant) return;
    const local = room.localParticipant;
    if (!local) return;
    const msg: ActionAccessControll = {
      type,
      from: local.identity ?? "unknown",
      to: user.identity ?? "unknown",
      at: Date.now(),
      target,
    };

    try {
      const payload = new TextEncoder().encode(JSON.stringify(msg));
      local.publishData(payload, {
        reliable: false,
        topic: target,
      });
    } catch (e) {
      console.warn("failed to publish cam-state", e);
    }
  };

  return { changeActionAccess };
}
